import moment from 'moment';
import React from 'react';
import styles from './eventCell.module.scss';
import { getWeekViewEventHeight } from '../../util';
import classnames from 'classnames';
import { isAlldayOrCrossEvent } from './util';
import { getIn18Text } from 'api';
const EventDetail = ({ event, hourHeight = 50, judgePast = true }) => {
    const isAllDayOrCross = isAlldayOrCrossEvent(event);
    const timeStr = `${moment(event.start).format('HH:mm')}-${moment(event.end).format('HH:mm')}`;
    const aboveHalfHour = moment(event.start).clone().add(30, 'minute').isBefore(moment(event.end));
    const isPast = !moment(event.end).clone().isAfter(moment());
    const styleObj = {
        color: event.textColor || '#ffffff',
        background: event.color || '#6ba9ff',
        borderColor: event.borderColor || '#6ba9ff',
    };
    const weekViewEventHight = getWeekViewEventHeight(moment(event.start), moment(event.end));
    return (React.createElement("div", { style: { height: '100%', width: '100%', background: '#ffffff' } },
        React.createElement("div", { className: classnames(styles.detailOuter, {
                [styles.isPast]: judgePast && isPast,
            }), style: styleObj }, isAllDayOrCross ? (React.createElement("span", null, event.summary || getIn18Text('WUZHUTI'))) : (React.createElement("span", { className: styles.detailInner },
            React.createElement("span", { style: {
                    maxHeight: weekViewEventHight,
                    minHeight: 20,
                    display: 'inline-block',
                    overflow: 'hidden',
                    float: 'left',
                    textDecoration: 'inherit',
                } }, event.summary || getIn18Text('WUZHUTI')),
            aboveHalfHour && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                timeStr)))))));
};
export default EventDetail;
